import { useQuery } from '@tanstack/react-query';
import { fetchAnalyticsSummary, type WindowDays } from '../services/analytics-service';

export function useAnalyticsSummary(shopId: string | null, windowDays: WindowDays) {
  return useQuery({
    queryKey: ['analytics-summary', shopId, windowDays],
    queryFn: () => fetchAnalyticsSummary(shopId!, windowDays),
    enabled: !!shopId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
